var _ = require('optimizely-client-fn');
var CHANGE_DATA_KEY = require('./constants').CHANGE_DATA_KEY;

/**
 * Retrieve change specific data from an HTMLElement
 * @module
 * @param {HTMLElement} element
 * @param {string} changeId
 * @param {string} changeApplierId
 * @returns {object|null}
 */
exports.getData = function(element, changeId, changeApplierId) {
  var identifier = getChangeIdentifier(changeId, changeApplierId);
  if (element[CHANGE_DATA_KEY] && element[CHANGE_DATA_KEY][identifier]) {
    return element[CHANGE_DATA_KEY][identifier];
  } else {
    return null;
  }
};

/**
 * Given a single element node, determine if change data has been applied
 * @param {HTMLElement} element
 * @returns {boolean}
 */
exports.hasData = function(element:HTMLElement): boolean {
  return Boolean(element && element[CHANGE_DATA_KEY] && !_.isEmpty(element[CHANGE_DATA_KEY]));
};

/**
 * Remove change specific data from an HTMLElement
 * @param {HTMLElement} element
 * @param {string} changeId
 * @param {string} changeApplierId
 */
exports.removeData = function (element:HTMLElement, changeId:string, changeApplierId:string) {
  if (element[CHANGE_DATA_KEY]) {
    delete element[CHANGE_DATA_KEY][getChangeIdentifier(changeId, changeApplierId)];
  }
};

/**
 * Set change specific data on an HTMLElement
 * @param {HTMLElement} element
 * @param {string} changeId
 * @param {string} changeApplierId
 * @param {object} value
 */
exports.setData = function (element:HTMLElement, changeId:string, changeApplierId:string, value:any) {
  if (typeof value !== 'object') {
    throw new Error('setData expects an object');
  }
  if (!element[CHANGE_DATA_KEY]) {
    element[CHANGE_DATA_KEY] = {} as any;
  }
  element[CHANGE_DATA_KEY][getChangeIdentifier(changeId, changeApplierId)] = value;
};

/**
 * Helper function to generate the correct id
 * @private
 * @param {string} changeId
 * @param {string} changeApplierId
 * @returns {string}
 */
function getChangeIdentifier(changeId:string, changeApplierId:string): string {
  return [changeId, changeApplierId].join('_');
}
